import { useQuery, useQueryClient } from '@tanstack/react-query'
import { listWorkShiftCustomFields } from 'api/company'
import { useAuthContext } from 'components/auth'
import { QueryOptions } from 'queries/types'
import { companyKey, workShiftCustomFieldsKey } from './keys'

export function useWorkShiftCustomFields(
  options: QueryOptions<typeof listWorkShiftCustomFields> & {
    includeDeleted?: boolean
  } = {}
) {
  const { includeDeleted = false, ...queryOptions } = options
  const { company } = useAuthContext()
  const companyId = company?.id

  return useQuery({
    ...queryOptions,
    queryKey: workShiftCustomFieldsKey(companyId, includeDeleted),
    queryFn: () => {
      if (!companyId) {
        throw new Error('Company id not found')
      }
      return listWorkShiftCustomFields(companyId, { includeDeleted })
    },
    enabled: !!companyId,
  })
}

export function useInvalidateWorkShiftCustomFields() {
  const queryClient = useQueryClient()
  const { company } = useAuthContext()

  return {
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [...companyKey, 'workShiftCustomFields', company?.id],
      }),
  }
}
